import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const SwitchbacksIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Switchbacks - zigzag path up slope */}
    <path d="M4 20l16-4" />
    <path d="M4 16l16-4" />
    <path d="M4 12l16-4" />
    <path d="M4 8l8-2" />
    <path d="M6 20l-2-4 4-4-4-4 4-4" />
    <path d="M18 16l2-4-2-4 2-4" />
  </svg>
);
